import type { FC } from 'react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { Button, Iconify, Stack, Typography } from '@pflegenavi/web-components';
import { LetterChip } from './LetterChip';
import { ChangeCashMode } from './model';
import { useCashManagementCapabilities } from './useCashManagementCapabilities';

interface AdjustCashFormStep1Props {
  nextStep: () => void;
  setMode: (mode: ChangeCashMode) => void;
  disabled?: boolean;
  disabledTooltipTitle?: string;
}

export const AdjustCashFormStep1: FC<AdjustCashFormStep1Props> = ({
  nextStep,
  setMode,
  disabled,
  disabledTooltipTitle,
}) => {
  const { t } = useTranslation();
  const { variant } = useCashManagementCapabilities();

  return (
    <Stack direction="column" gap={1} sx={{ paddingY: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <LetterChip>B</LetterChip>
        <Typography variant="h6" fontWeight={700}>
          {t('cashManagement.adjust-title')}
        </Typography>
      </Stack>

      <Typography variant="body2">
        <Trans
          i18nKey="cashManagement.adjust-subtitle"
          components={{ bold: <strong /> }}
        />{' '}
        <Trans
          i18nKey={`cashManagement.adjust-subtitle-${variant}`}
          components={{ bold: <strong /> }}
        />
      </Typography>

      <Stack direction="row" gap={1} justifyContent="end">
        <Tooltip title={disabled ? disabledTooltipTitle ?? '' : ''}>
          <span>
            <Button
              name={'changeCashAdjustCash'}
              variant="contained"
              disabled={disabled}
              endIcon={
                <Iconify
                  sx={{
                    ml: 0.5,
                    width: 16,
                  }}
                  icon="teenyicons:adjust-horizontal-solid"
                />
              }
              onClick={() => {
                setMode(ChangeCashMode.Adjust);
                nextStep();
              }}
            >
              {t('cashManagement.adjust-cash')}
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </Stack>
  );
};
